import React from 'react'
import PropTypes from 'prop-types'

import FontIcon from 'material-ui/FontIcon'

import JobStatus from 'infra/JobStatus'
import ReminderIcon from 'resources/reminder_icon.svg'

const STATUS_INDICATOR_SIZE = 16
const REMINDER_INDICATOR_SIZE = 12

export default class EventCardIndicators extends React.Component {

  static propTypes = {
    showReminder: PropTypes.bool,
    showSource: PropTypes.bool,
    jobStatus: PropTypes.object,
    sourceColor: PropTypes.string
  }

  addIndicator = (list, indicator) => {
    if (list.length > 0) {
      list.push(<div key={`margin-${indicator.key}`} style={{ marginLeft: 2 }} />)
    }
    list.push(indicator)
  }

  render() {
    const indicators = []
    if (this.props.showReminder) {
      this.addIndicator(indicators,
        <img
          key='image'
          src={ReminderIcon}
          width={REMINDER_INDICATOR_SIZE}
          height={REMINDER_INDICATOR_SIZE} />
      )
    }
    if (this.props.jobStatus === JobStatus.IN_PROGRESS) {
      this.addIndicator(indicators,
        <FontIcon key='status' className="material-icons" style={{ fontSize: STATUS_INDICATOR_SIZE }} color="rgba(0, 0, 0, 0.54)">
          schedule
        </FontIcon>
      )
    }
    if (this.props.showSource) {
      this.addIndicator(indicators,
        <div key='source'>
          <div style={styles.circle(this.props.jobStatus, this.props.sourceColor)}></div>
        </div>
      )
    }
    return (
      <div style={styles.container}>
        { indicators }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: 4
  },
  circle: (jobStatus, calendarColor) => ({
    width: 10,
    height: 10,
    borderRadius: 10,
    backgroundColor: calendarColor,
    border: jobStatus === JobStatus.COMPLETED
      ? '1px solid #dbefff'
      : '1px solid #527da3'
  })
}


// WEBPACK FOOTER //
// ./src/schedule/common/EventCardIndicators.js